var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_683_1020)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.0559 23.1933L39.3475 19.3392L47.0559 15.4848C48.4347 14.7956 48.4361 12.821 47.0559 12.1306L24.9308 1.0681C24.6704 0.938058 24.3833 0.870361 24.0922 0.870361C23.8012 0.870361 23.5141 0.938058 23.2536 1.0681L1.12855 12.1306C-0.250326 12.8203 -0.251732 14.7948 1.12855 15.4848L8.8368 19.3392L1.12837 23.1933C-0.250419 23.8828 -0.251826 25.857 1.12837 26.5474L8.8369 30.4017L1.12846 34.2558C-0.250326 34.9454 -0.251732 36.9196 1.12846 37.6099L23.2535 48.6725C23.5139 48.8026 23.801 48.8703 24.0921 48.8703C24.3832 48.8703 24.6703 48.8026 24.9307 48.6725L47.0558 37.6099C48.4347 36.9203 48.4361 34.9461 47.0558 34.2557L39.3476 30.4017L47.056 26.5474C48.4348 25.8581 48.4362 23.8836 47.056 23.1932L47.0559 23.1933ZM24.0921 4.84165L42.0245 13.8079L24.0921 22.7739L6.15986 13.8079L24.0921 4.84165ZM42.0245 35.933L24.0921 44.899L6.15986 35.933L13.0296 32.498L23.2535 37.6099C23.5139 37.7401 23.801 37.8078 24.0921 37.8078C24.3832 37.8078 24.6703 37.7401 24.9307 37.6099L35.1547 32.4979L42.0245 35.933ZM24.0921 33.8365L6.15986 24.8705L13.0296 21.4355L23.2535 26.5474C23.5139 26.6775 23.801 26.7453 24.0921 26.7453C24.3832 26.7453 24.6703 26.6775 24.9307 26.5474L35.1547 21.4354L42.0245 24.8705L24.0921 33.8365Z",
    fill: "#AAD2EF",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_683_1020"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.870361)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/reportIcon.db919ec547dce10c3392866d1500a68d.svg";
export { ForwardRef as ReactComponent };